import { CanvasContext } from "client/contexts/ResizeEditor/Canvas";
import { ga } from "client/utils/adsense/ga";
import { gtag } from "client/utils/adsense/gtag";
import { flipImage } from "client/utils/imageEdit/flipImage";
import { loadImageToCanvas } from "client/utils/imageEdit/loadImageToCanvas";
import { useContext, useState } from "react";
import { flipRotateSelector } from "store/features/flipRotate/selectors/flipRotateSelector";
import { FlipRotateState } from "store/features/flipRotate/types";
import { useAppSelector } from "store/store";

export const useAction = () => {
    const { image, flip } = useAppSelector(flipRotateSelector, equalityFn);
    const { initialImageRef } = useContext(CanvasContext);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleDownloadAnalytics = () => {
        ga("send", {
            hitType: "pageview",
            page: "/vp/flip_image/export_started/",
            title: "Image Flipper Export Started",
        });

        ///event
        gtag("event", "Export Started", {
            event_category: "Image Flipper",
            event_label: "Editor Page",
        });
    };

    const handleClick = async () => {
        const initialImage = initialImageRef?.current;
        if (isProcessing || !initialImage) return;
        handleDownloadAnalytics();
        setIsProcessing(true);
        const canvas = document.createElement("canvas");

        const { saveAs } = (await import("file-saver")).default;
        const mime = await import("mime-types");
        const img = new Image();
        canvas.width = initialImage.width;
        canvas.height = initialImage.height;
        img.width = initialImage.width;
        img.height = initialImage.height;
        const src = initialImage.getAttribute("src") || "";
        await flipImage(flip.horizontal, flip.vertical, img, src, image.originalWidth, image.originalHeight);
        await loadImageToCanvas(canvas, img.getAttribute("src") || "");

        canvas.toBlob((blob) => {
            if (!blob) return;
            const url = URL.createObjectURL(blob);
            saveAs(url, image.title);

            setIsProcessing(false);
        }, mime.lookup(image.title).toString());
    };

    return { handleClick, isProcessing };
};

const equalityFn = (left: FlipRotateState, right: FlipRotateState) => {
    if (
        JSON.stringify(left.image) !== JSON.stringify(right.image) ||
        JSON.stringify(left.flip) !== JSON.stringify(right.flip)
    ) {
        return false;
    }

    return true;
};
